module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u81F3 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "\u5DF2\u9078\u53D6 ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u5B8C\u6210\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
  "maximumDate": "\u6700\u5F8C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
  "minimumDate": "\u7B2C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
  "next": "\u4E0B\u4E00\u9801",
  "previous": "\u4E0A\u4E00\u9801",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u958B\u59CB\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
  "todayDate": function todayDate(args) {
    return "\u4ECA\u5929\uFF0C".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u5DF2\u9078\u53D6\u4ECA\u5929\uFF0C".concat(args.date);
  }
};